<template>
    <div id="carousel" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
            <li v-for="(img, idx) in images" :key="idx" :data-slide-to="idx" :class="[{ 'active' : active == idx }]"></li>
        </ol>
        <div class="carousel-inner">
                <div v-for="(img, idx) in images" :key="idx" :class="['carousel-item', { 'active' : active == idx }, active == idx ? 'fade-in' : 'fade-out']">
                    <img class="d-block w-100" :src="img.image" :alt="img.alt" :id="'carousel-img-' + idx" />
                </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'carousel',
    props: {
        images: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            active: 0
        }
    },
    mounted(ev) {
        setInterval(() => {
            if(this.active < this.images.length - 1)
            {
                this.active++;
            } else 
            {
                this.active = 0;
            }
        }, 5000)
    }
}
</script>

<style scoped lang="scss">

.fade-in {
    opacity: 1;
	animation-name: fadeInOpacity;
	animation-iteration-count: 1;
	animation-timing-function: ease-out;
    animation-duration: 1s;
}

@keyframes fadeInOpacity {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.fade-out {
	opacity: 0;
	animation-name: fadeOutOpacity;
	animation-iteration-count: 1;
	animation-timing-function: ease-in;
	animation-duration: 1s;
}

@keyframes fadeOutOpacity {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>